var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHouseinline = function SvgHouseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4582 4.2V0.666667H10.3332V2.4L7.49984 0L0.416504 6H2.5415V11.3333H6.7915V7.33333H8.20817V11.3333H12.4582V6H14.5832L12.4582 4.2ZM11.0415 10H9.62484V6H5.37484V10H3.95817V4.79333L7.49984 1.79333L11.0415 4.79333V10Z",
    fill: "#784F33"
  })));
};

export default SvgHouseinline;